import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
  HostListener,
  HostBinding,
} from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "src/app/auth/fire-auth/authentication.service";
import { Router } from "@angular/router";
import { fromEvent } from "rxjs";
import {
  throttleTime,
  map,
  pairwise,
  distinctUntilChanged,
  share,
  filter,
} from "rxjs/operators";

enum Direction {
  Up = "Up",
  Down = "Down",
}
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Input() menuItems: any[];
  private _mobileQueryListener: () => void;
  mobileQuery: MediaQueryList;
  shouldRun = true;
  fillerNav: any[];
  fillerContent = Array.from(
    { length: 50 },
    () =>
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
       labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
       laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
       voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
       cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`
  );

  constructor(
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.fillerNav = this.menuItems;
  }

  ngAfterViewInit() {
    const scroll$ = fromEvent(window, "scroll").pipe(
      throttleTime(10),
      map(() => window.pageYOffset),
      pairwise(),
      map(([y1, y2]): Direction => (y2 < y1 ? Direction.Up : Direction.Down)),
      distinctUntilChanged(),
      share()
    );

    const scrollUp$ = scroll$.pipe(
      filter((direction) => direction === Direction.Up)
    );

    const scrollDown = scroll$.pipe(
      filter((direction) => direction === Direction.Down)
    );

    scrollUp$.subscribe(() => console.log("scrolling up"));
    scrollDown.subscribe(() => console.log("scrolling down"));
  }

  @HostListener("window:scroll", ["$event"]) onScrollEvent($event) {
    // console.log($event['Window']);
    console.log("scrolling1");
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  changeLang(language: string) {
    this.translate.use(language);
  }

  logout() {
    this.authenticationService
      .logOut()
      .then((data) => this.successLogOut(data))
      .catch((data) => this.errorLogOut(data));
  }

  successLogOut(data) {
    alert(`Session finalized`);
    this.router.navigate(["login"]);
  }
  errorLogOut(data) {
    alert(`An error has occured!: ${data} `);
  }
}
